import React, { useEffect, useState } from "react";
import LocationIcon from "../../assets/img/orders/locationIcon.png";

import { CONSTANTS } from "config/constant";
import { Button, Card, Checkbox, Col, Modal, Row, Select } from "antd";
import EditIcon from "../../assets/img/orders/Edit.png";

import minusIcon from "../../assets/img/orders/minusIcon.png";
import plusIcon from "../../assets/img/orders/plusIcon.png";
import editCollection from "../../assets/img/orders/editcollection.png";
import collectionDate from "../../assets/img/orders/collectionDate.png";
import deliverytime from "../../assets/img/orders/deliverytime.png";
import editdeleivery from "../../assets/img/orders/editdeleivery.png";
// import CalendarSlot from "components/fields/CalendarSlot";
import PaymentModal from "./PaymentModal";
import CreateOrderUser from "views/admin/orderManagement/OrderUser/CreateOrderUser";
import { UseUser } from "config/selectedUserContext";
import { UseItemList } from "config/itemListContext";
import DetailModalCards from "components/Modal/DetailModalCards";
import { API_DELIVERY_ORDER } from "api/order-management";
import { API_COUPEN_ORDER } from "api/order-management";
import { toast } from "react-toastify";
import { API_CREATE_ORDER } from "api/order-management";
import { Option } from "antd/es/mentions";
import { API_LIST_MAIN_LAUNDRY } from "api/main-laundry-management";
import { API_LIST_STORE } from "api/store-managemnt";
import CalendarSlot from "components/Modal/CalendarSlot";

import cashondelivery from "../../assets/img/orders/cashondelivery.png";
// import cashondelivery from "../../assets";

import creditCard from "../../assets/img/orders/credit.png";
import handonCash from "../../assets/img/orders/handonCash.png";
import moment from "moment";
import { API_PAYMENT_ORDER } from "api/order-management";
import { UseItemNotes } from "config/Notes";
import { json, useNavigate } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import { RiDeleteBin6Line } from "react-icons/ri";
import { TiDelete } from "react-icons/ti";
import CalendarSlotDelivery from "components/Modal/CalendarSlotDelivery";
import { API_RECIEVED_AMOUNT } from "api/order-management";
import { useSelector } from "react-redux";
import { API_TAX_ORDER } from "api/order-management";
import { API_CALCULATE_AMOUNT } from "api/order-management";
import { useTranslation } from "react-i18next";
const OrderCard = ({
  itemCounts,
  setItemCounts,
  totalPrice,
  setTotalPrice,
  catagory,
  selectedOrderType,
  setSelectedOrderType,
}) => {
  const { selectUser, selectedUser } = UseUser();
  const { alItemsList, setAllitemsList } = UseItemList();
  const [data, setData] = useState([]);
  const [dataStore, setDataStore] = useState([]);
  const [deliveryTime, setDeliveryTime] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [pickUpTime, setPickUpTime] = useState(null);
  const [selectedStore, setSelectedStore] = useState("");
  const [orderNote, setOrderNote] = useState("");

  const [partialAmount, setPartialAmount] = useState("");

  const [modalVisibleUser, setModalVisibleUser] = useState(false);
  const [modalVisibleOrder, setModalVisibleOrder] = useState(false);

  const [slotVisible, setSlotVisible] = useState(false);

  const [slotVisibleDelvery, setSlotVisibleDelvery] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  // const [itemsList, setItemsList] = useState([]);
  // const [itemCounts, setItemCounts] = useState({});
  const [paymentVisible, setPaymentVisible] = useState(false);
  const [coupenVisible, setCoupenVisible] = useState(false);
  // const [totalPrice, setTotalPrice] = useState(0); // State to hold total price
  const [totalItems, setTotalItems] = useState(0); // State for total number of items
  const [deliveryFee, setDeliveryFee] = useState(0);
  const [tax, setTax] = useState(0);
  const [coupenCode, setCoupenCode] = useState("");
  const [coupenData, setCoupenData] = useState("");
  const [selectedCustmerType, setSelectedCustmerType] = useState("walking");
  const [selectedPaymentStatus, setSelectedPaymentStatus] = useState("unpaid");
  const [orderId, setOrderId] = useState("");
  // const [itemNotes, setItemNotes] = useState({});
  const userProfile = useSelector((state) => state?.user?.profileData);
  console.log(userProfile, "userProfileData");
  const [mainLaundry, setMainLaundry] = useState("");
  const [userData, setUserData] = useState("");
  const [store, setStore] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const { updateNote, itemNotes } = UseItemNotes();
  const { t } = useTranslation();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10, // adjust as needed
    totalPages: 1, // initial value, will be updated on data fetch
  });

  const [paginationStore, setPaginationStore] = useState({
    current: 1,
    pageSize: 10, // adjust as needed
    totalPages: 1, // initial value, will be updated on data fetch
  });
  const [paymentInfo, setPaymentInfo] = useState({
    amountDue: 0,
    amountPaid: 0,
    deliveryFee: 0,
    discount: 0,
    subtotal: 0,
    taxAmount: 0,
    totalAmount: 0,
  });

  const [loading, setLoading] = useState(false);
  const [loadingorder, setLoadingOrder] = useState(false);

  const [loadingStore, setLoadingStore] = useState(false);
  const Navigate = useNavigate();
  const handleCheckboxChange = (option) => {
    if (selectedCustmerType === option) {
      setSelectedCustmerType(null); // Uncheck if already selected
    } else {
      setSelectedCustmerType(option); // Check the selected option
    }
  };
  const handleCheckboxChangeStatus = (option) => {
    if (selectedPaymentStatus === option) {
      setSelectedPaymentStatus(null); // Uncheck if already selected
    } else {
      setSelectedPaymentStatus(option); // Check the selected option
    }
  };
  const handleCardClick = (item) => {
    console.log("item click", item);
    setSelectedItem(item);
    setIsModalVisible(true);
  };
  const handleConfirm = (time) => {
    console.log("Selected Delivery Time:", time);

    if (slotVisibleDelvery === true) {
      if (time) {
        setDeliveryTime(time);
        setPickUpTime(time);
        setSlotVisibleDelvery(false);
      }
    } else {
      if (slotVisible === true) {
        if (time) {
          setPickUpTime(time);
          setSlotVisible(false);
        }
      }
    }
  };
  console.log(pickUpTime, "pickUpTime ==>");
  const handleRemoveClick = (item) => {
    setAllitemsList((prevSelectedItems) =>
      prevSelectedItems.filter((selected) => selected._id !== item._id)
    );

    // Remove item counts for the removed item
    setItemCounts((prevItemCounts) => {
      const updatedCounts = { ...prevItemCounts };
      item.item_service.forEach((service) => {
        delete updatedCounts[service._id];
      });
      return updatedCounts;
    });
    setIsDeleteModalVisible(false);
  };
  // const calculateTotalPrice = (item) => {
  //   console.log("item cal", item);
  //   const total = item?.item_service?.reduce(
  //     (total, service) => total + Number(service?.price),
  //     0
  //   );
  //   const itemCount = itemCounts[item._id] || 1;
  //   return total * itemCount;
  // };

  // const calculateTotalPrice = (item) => {
  //   // Initialize total price
  //   let totalPrice = 0;

  //   // Get item count
  //   const itemCount = itemCounts[item._id] || 0;

  //   // Iterate over each service in item_service
  //   item?.item_service?.forEach((service) => {
  //     const servicePrice = Number(service?.price);
  //     const serviceItemCount = itemCounts[service?._id] || 0; // Get count for this service ID

  //     // Calculate total price for this service and add to totalPrice
  //     totalPrice += servicePrice * serviceItemCount;
  //   });

  //   // Multiply totalPrice by itemCount (count of this item)
  //   totalPrice *= itemCount;

  //   return totalPrice;
  // };
  const calculateTotalPrice = (item) => {
    return item?.item_info
      ? item?.item_info?.item_service.reduce((total, service) => {
          const quantity =
            itemCounts[service._id] || Number(service.quantity) || 0;
          const price = service.price ? parseFloat(service.price) : 0;
          return total + quantity * price;
        }, 0)
      : item?.item_service.reduce((total, service) => {
          const quantity =
            itemCounts[service._id] || Number(service.quantity) || 0;
          const price = service.price ? parseFloat(service.price) : 0;
          return total + quantity * price;
        }, 0);
  };

  // const calculateTotalPrice = (item) => {
  //   console.log("item cal", item);

  //   // Initialize total price
  //   let totalPrice = 0;

  //   // Iterate over each service in item_service
  //   item?.item_service?.forEach((service) => {
  //     const serviceId = service?._id;
  //     const servicePrice = Number(service?.price);
  //     const itemCount = itemCounts[serviceId] || 1; // Get count for this service ID

  //     // Calculate total price for this service and add to totalPrice
  //     totalPrice += servicePrice * itemCount;
  //   });

  //   return totalPrice;
  // };
  // const handleCountMinus = (item) => {
  //   setItemCounts((prevItemCounts) => {
  //     const newCount = (prevItemCounts[item._id] || 1) - 1;
  //     if (newCount < 1) return prevItemCounts; // Prevent count from going below 1
  //     return {
  //       ...prevItemCounts,
  //       [item._id]: newCount,
  //     };
  //   });
  // };
  // const handleCountPlus = (item) => {
  //   setItemCounts((prevItemCounts) => ({
  //     ...prevItemCounts,
  //     [item._id]: (prevItemCounts[item._id] || 1) + 1,
  //   }));
  // };

  const handleCountMinus = (itemId) => {
    console.log("handleCountMinus", itemId);
    setItemCounts((prevCounts) => ({
      ...prevCounts,
      [itemId]: Math.max((prevCounts[itemId] || 1) - 1, 0), // Ensure count doesn't go below 0
    }));
  };

  const handleCountPlus = (itemId) => {
    console.log("handleCountPlus itemId:", itemId); // Ensure itemId is correctly logged
    setItemCounts((prevCounts) => ({
      ...prevCounts,
      [itemId]: (prevCounts[itemId] || 0) + 1,
    }));
  };

  const handleScroll = (e) => {
    const { target } = e;
    if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
      if (pagination.current < pagination.totalPages) {
        setPagination((prevPagination) => ({
          ...prevPagination,
          current: prevPagination.current + 1,
        }));
      }
    }
  };
  const handleScrollStore = (e) => {
    const { target } = e;
    if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
      if (paginationStore.current < pagination.totalPages) {
        setPaginationStore((prevPagination) => ({
          ...prevPagination,
          current: prevPagination.current + 1,
        }));
      }
    }
  };
  const handleRadioChange = (event) => {
    setPaymentMethod(event.target.value);
    if (event.target.value === "hand_cash") {
      setSelectedPaymentStatus("paid");
    } else {
      setSelectedPaymentStatus("unpaid");
    }
  };
  const handleApplyCoupon = async (price) => {
    try {
      const payload = {
        coupon_code: coupenCode,
        // total_amount: price,
        user_id: selectedUser?._id,
      };
      if (selectedUser) {
        const response = await API_COUPEN_ORDER(payload);
        // setCoupenData(response?.discounted_amount);
        setCoupenData(response?.coupon);
        console.log(response?.coupon, "couponcode");
        toast.success("Coupon applied successfully!");
      } else {
        toast.error("Please select user first which you want to give coupen");
      }
      setCoupenVisible(false);
    } catch (error) {
      console.error("Error applying coupon:", error);
      toast.error(error?.response?.data?.error);
    }
  };

  const fetchDataMainLaundry = async (page) => {
    try {
      setLoading(true);
      const params = {
        page: page,
        limit: pagination.pageSize,
        name: "",
      };
      const newData = await API_LIST_MAIN_LAUNDRY(params);
      setData((prevData) => [...prevData, ...newData.laundry]);
      setPagination((prevPagination) => ({
        ...prevPagination,
        totalPages: newData.totalPages,
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDataStore = async (page) => {
    try {
      setLoadingStore(true);
      const params = {
        page: page,
        limit: paginationStore.pageSize,
        laundry: mainLaundry,
      };
      const newData = await API_LIST_STORE(params);
      // setDataStore((prevData) => [...prevData, ...newData.providers]);
      setDataStore(newData?.providers);

      setPaginationStore((prevPagination) => ({
        ...prevPagination,
        totalPages: newData.total_pages,
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingStore(false);
    }
  };

  const RecivedAmount = async () => {
    try {
      setLoading(true);
      const newData = await API_RECIEVED_AMOUNT({
        amount: Number(partialAmount),
        order_id: orderId,
      });
      toast.success("Amount Recieved");
      setLoading(false);

      // setDeliveryFee(newData?.delivery_fee);
      console.log("recived amoubt", newData);
      Navigate(`/admin/order-management/${orderId}`);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);

      // setLoading(false);
    }
  };

  // const updateNote = (itemId, note) => {
  //   setItemNotes((prevNotes) => ({
  //     ...prevNotes,
  //     [itemId]: note,
  //   }));
  // };
  useEffect(() => {
    fetchDataStore(pagination.current);
  }, [paginationStore.current, mainLaundry]);
  useEffect(() => {
    fetchDataMainLaundry(pagination.current);
  }, [pagination.current]);

  // useEffect(() => {
  //   let itemsCount = 0;
  //   const total = alItemsList?.reduce((total, item) => {
  //     const itemTotal = calculateTotalPrice(item);
  //     itemsCount += itemCounts[item._id] || 0;
  //     return total + itemTotal;
  //   }, 0);
  //   setTotalPrice(total);
  //   setTotalItems(itemsCount);
  //   console.log("itemsCount",itemsCount)
  // }, [alItemsList, itemCounts]);
  console.log(selectedStore, "adslfjsdhlfkjsd");
  useEffect(() => {
    let itemsCount = 0;
    const total = alItemsList?.reduce((total, item) => {
      const itemTotal = calculateTotalPrice(item);

      // Sum the quantities of all services within the item
      const serviceCount = item?.item_service?.reduce((count, service) => {
        return (
          count + (itemCounts[service._id] || Number(service.quantity) || 0)
        );
      }, 0);

      itemsCount += serviceCount;
      return total + itemTotal;
    }, 0);

    setTotalPrice(total);
    setTotalItems(itemsCount);
    console.log("itemsCount effect", itemsCount);
  }, [alItemsList, itemCounts]);

  // let discount = 0;

  // if (coupenData) {
  //   if (coupenData.coupon_type === "fixed") {
  //     discount = coupenData?.coupon_discount;
  //   } else if (coupenData?.coupon_type === "percentage") {
  //     // Apply percentage discount
  //     discount = (tax + totalPrice) * (coupenData?.coupon_discount / 100);
  //     console.log("discount insdie", discount);
  //   }
  // }
  // let total_calulated_price_withoutdilivery = tax + totalPrice - discount;

  // let total_calulated_price = deliveryFee + tax + totalPrice - discount;

  let discount = 0;

  if (coupenData) {
    if (coupenData.coupon_type === "fixed") {
      discount = coupenData?.coupon_discount;
    } else if (coupenData?.coupon_type === "percentage") {
      // Apply percentage discount
      let totalAmount = Number(deliveryFee) + Number(totalPrice);

      discount = (coupenData?.coupon_discount / 100) * totalAmount;

      console.log("discount insdie", discount);
      console.log("totalAmount", totalAmount);
    }
  }
  let total_calulated_price_withoutdilivery =
    deliveryFee + totalPrice - discount;

  let total_calulated_price_withoutdiliverys = totalPrice - discount;
  let total_calulated_price = deliveryFee + tax + totalPrice - discount;

  const FetchDeliveryFee = async () => {
    try {
      const newData = await API_DELIVERY_ORDER(
        coupenData
          ? { total_amount: total_calulated_price_withoutdiliverys }
          : { total_amount: totalPrice }
      );
      setDeliveryFee(newData?.delivery_fee);
      setTax(newData?.tax_amount);

      console.log("delivery Fee", newData);
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const FetchTax = async () => {
    try {
      const newData = await API_TAX_ORDER(
        coupenData
          ? {
              total_amount: total_calulated_price_withoutdilivery + deliveryFee,
            }
          : { total_amount: totalPrice + deliveryFee }
      );
      setTax(newData?.tax_amount);

      console.log("delivery Fee", newData);
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  // useEffect(() => {
  //   FetchDeliveryFee();
  // }, [totalPrice, coupenData]);
  // useEffect(() => {
  //   FetchTax();
  // }, [totalPrice, coupenData, total_calulated_price_withoutdilivery]);

  const itemsPayload = alItemsList?.map((item) => {
    const totalQuantity = item?.item_service?.reduce((total, service) => {
      return total + (Number(itemCounts[service._id]) || 0);
    }, 0);
    return {
      order_note: itemNotes[item?._id] || "", // Add the note here
      handle_note: itemNotes[item?._id] || "", // Add the note here
      category_id: catagory,
      // item_service:
      //   item?.item_service?.map((service) => ({
      //     item_service_id: service?.item_service,
      //     price: Number(service?.price || 0),
      //     quantity: Number(itemCounts[service?._id]) || 0, // Add the count here
      //   })) || [],
      item_service:
        item?.item_service
          ?.filter((service) => Number(itemCounts[service._id]) > 0) // Filter out services with quantity 0
          .map((service) => ({
            item_service_id: service?.item_service,
            price: Number(service?.price || 0),
            quantity: Number(itemCounts[service?._id]) || 0, // Add the count here
          })) || [],

      item_id: item?._id,
      total_quantity: totalQuantity,
      // total_quantity: itemCounts[item._id]?.toString() || "1",
      total_price: calculateTotalPrice(item),
    };
  });
  const createOrderPayload = () => {
    const selectedAddress = selectedUser?.address?.find(
      (address) => address?.is_selected === true
    );

    const payload = {
      total_items: totalItems,
      delivery_fee: paymentInfo?.deliveryFee,

      // delivery_fee: deliveryFee,
      // tax: tax,
      tax: paymentInfo?.taxAmount,
      order_note: orderNote,
      // discounted_amount: discount || 0,
      discounted_amount: paymentInfo?.discount || 0,
      sub_total: totalPrice,
      // total: totalPrice + deliveryFee + tax - (total_calulated_price || 0),
      // total: total_calulated_price,
      total: paymentInfo?.totalAmount,
      currency: "SAR", // Adjust based on your currency logic
      is_discounted_order: !!coupenData,
      order_type: selectedOrderType, // Adjust based on your order type logic
      order_scheme: "normal", // Adjust based on your order scheme logic
      order_pickup_time: {
        from: pickUpTime?.from ? pickUpTime?.from : moment(new Date()).unix(),
        to: pickUpTime?.to ? pickUpTime?.to : moment(new Date()).unix(),
      },
      customer_type: selectedCustmerType,
      items: itemsPayload,
      order_delivery_time: {
        from: deliveryTime?.from,
        to: deliveryTime?.to,
      },
      order_pickup_address: {
        first_name:
          selectedCustmerType === "walking"
            ? process.env.REACT_APP_APPLICATION_NAME === "admin"
              ? selectedStore && selectedStore?.store_owner_info[0]?.first_name
              : userData?.laundry_name || userData?.store_name
            : selectedUser?.first_name || "",
        location:
          process.env.REACT_APP_APPLICATION_NAME === "admin"
            ? selectedCustmerType === "walking"
              ? selectedStore && selectedStore?.address
              : selectedStore?.address || ""
            : userData?.location?.address ?? userData?.address,
        last_name:
          selectedCustmerType === "walking"
            ? process.env.REACT_APP_APPLICATION_NAME === "admin"
              ? selectedStore && selectedStore?.store_owner_info[0]?.last_name
              : ""
            : selectedUser?.last_name || "",
        phone_no:
          selectedCustmerType === "walking"
            ? process.env.REACT_APP_APPLICATION_NAME === "admin"
              ? selectedStore && selectedStore?.store_owner_info[0]?.phone_no
              : userData?.phone_no || ""
            : selectedUser?.phone_no || "",
        building:
          selectedCustmerType === "walking"
            ? ""
            : selectedStore?.building ?? "",
        apartment:
          selectedCustmerType === "walking"
            ? ""
            : selectedStore?.apartment ?? "",
        floor:
          selectedCustmerType === "walking" ? "" : selectedStore?.floor ?? "",
        street:
          selectedCustmerType === "walking" ? "" : selectedStore?.street ?? "",
        additional_directions:
          selectedCustmerType === "walking"
            ? ""
            : selectedStore?.additional_directions ?? "",
        geo:
          selectedCustmerType === "walking"
            ? process.env.REACT_APP_APPLICATION_NAME === "admin"
              ? selectedStore && selectedStore?.geo
              : userData?.geo || {
                  type: "Point",
                  coordinates: [33.5968788, 73.0528412],
                  _id: "66c4d59c24b5e807ed5ff471",
                }
            : {
                coordinates: [
                  selectedStore?.geo?.coordinates?.[0],
                  selectedStore?.geo?.coordinates?.[1],
                ],
              },
      },
      order_delivery_address: {
        first_name: selectedUser?.first_name || "",
        location: selectedAddress?.location || "",
        last_name: selectedUser?.last_name || "",
        phone_no: selectedUser?.phone_no || "",
        building: selectedAddress?.building || "",
        apartment: selectedAddress?.apartment || "",
        floor: selectedAddress?.floor || "",
        street: selectedAddress?.street || "",
        additional_directions: selectedAddress?.additional_directions || "",
        geo: {
          coordinates: [
            selectedAddress?.geo?.coordinates?.[0],
            selectedAddress?.geo?.coordinates?.[1],
          ],
        },
      },
      payment_type: paymentMethod,
      is_discounted_order: coupenData ? true : false,
      coupon_details: {
        coupon_code: coupenCode,
      },
      payment_status: selectedPaymentStatus,
      order_category: catagory, // Replace with actual category ID
      // main_laundry: mainLaundry, // Replace with actual provider ID
      main_laundry: "66a36f36a8b7d2b43551a939",
      order_provider_before_service: store,
      order_user: selectedUser?._id, // Replace with actual user ID
    };

    return payload;
  };

  const createOrder = async () => {
    // if (!mainLaundry) {
    //   toast.error("please select laundry");
    // } else
    if (!selectedUser) {
      toast.error("please Add user first");
    } else if (!deliveryTime) {
      toast.error("please select Delivery Time");
    } else if (!alItemsList.length > 0) {
      toast.error("please select at least one item for proceeding order");
    } else if (!paymentMethod) {
      toast.error("please select any Payment method");
    } else {
      setLoadingOrder(true);

      try {
        const payload = createOrderPayload();
        // Replace with actual API endpoint and method paymentMethod === "cash_on_delivery"
        var responseOrder = await API_CREATE_ORDER(payload);
        toast.success("Order created successfully!");
        setOrderId(responseOrder?.order?._id);
        setLoadingOrder(false);

        if (
          (paymentMethod === "cash_on_delivery" &&
            selectedOrderType == "express") ||
          paymentMethod === "credit_card"
          //  &&
          // selectedOrderType === "express"
        ) {
          if (responseOrder) {
            try {
              const payloads = {
                metaData: {
                  paymentType:
                    selectedOrderType === "express" &&
                    paymentMethod === "cash_on_delivery"
                      ? "partial_deposit"
                      : "order",
                  order_id: responseOrder?.order?._id, //enum: ["order","wallet",partial_deposit]};
                },
              };
              // Replace with actual API endpoint and method
              const response = await API_PAYMENT_ORDER(payloads);

              const redirectURL = response?.redirectURL;
              console.log("response payment", response);
              if (redirectURL) {
                window.open(redirectURL, "_blank"); // Open the URL in a new tab
              }
              console.log("Order created successfully:", response);
              Navigate(`/admin/order-management/${responseOrder?.order?._id}`);
            } catch (error) {
              toast.error(
                error?.response?.data?.exception ?? "Something went Wrong"
              );
              // setLoadingOrder(false);

              console.error("Error creating order:", error);
              // Handle error, e.g., show error message to user rounded-lg bg-white p-6 shadow-lg
            }
          }
          Navigate(`/admin/order-management/${responseOrder?.order?._id}`);
        } else if (
          paymentMethod === "hand_cashaaa" &&
          selectedOrderType === "express"
        ) {
          setModalVisibleOrder(true);
          console.log("Hey......");
          // {
          //   if (responseOrder) {
          //     try {
          //       const payloads = {
          //         metaData: {
          //           paymentType:
          //             selectedOrderType === "express" &&
          //             paymentMethod === "cash_on_delivery"
          //               ? "partial_deposit"
          //               : "order",
          //           order_id: responseOrder?.order?._id, //enum: ["order","wallet",partial_deposit]};
          //         },
          //       };
          //       // Replace with actual API endpoint and method
          //       const response = await API_PAYMENT_ORDER(payloads);

          //       const redirectURL = response?.redirectURL;
          //       console.log("response payment", response);
          //       if (redirectURL) {
          //         window.open(redirectURL, "_blank"); // Open the URL in a new tab
          //       }
          //       console.log("Order created successfully:", response);
          //     } catch (error) {
          //       toast.error(
          //         error?.response?.data?.exception ?? "Something went Wrong"
          //       );
          //       // setLoadingOrder(false);

          //       console.error("Error creating order:", error);
          //       // Handle error, e.g., show error message to user rounded-lg bg-white p-6 shadow-lg
          //     }
          //   }
          // }
        } else {
          Navigate(`/admin/order-management/${responseOrder?.order?._id}`);
        }
        // Navigate(`/admin/order-management/${responseOrder?.order?._id}`);
      } catch (error) {
        toast.error(
          error?.responseOrder?.data?.exception ?? "Something went Wrong"
        );
        setLoadingOrder(false);

        console.error("Error creating order:", error);
        // Handle error, e.g., show error message to user rounded-lg bg-white p-6 shadow-lg
      }
    }
  };
  useEffect(() => {
    if (selectedCustmerType !== "call") {
      setPickUpTime({
        from: moment(new Date()).unix(),
        to: moment(new Date()).unix(),
      });
    }
  }, [selectedCustmerType]);

  // };

  // let total_calulated_price = deliveryFee + tax + (coupenData || 0);
  const closeDeliveryModal = () => {
    setSlotVisibleDelvery(false);
    setPickUpTime(null);
  };
  useEffect(() => {
    const res = JSON.parse(localStorage.getItem("userData"));
    setUserData(res?.data);
  }, []);
  console.log("SelectedOrder", userData);
  console.log("alItemsList", alItemsList);
  console.log("coupeb data===>", coupenData);

  // --------------------------Calucations-------------------------------------

  const calculateAmount = async () => {
    try {
      const payload = {
        items: itemsPayload,
        coupon_details: coupenData ? { coupon_code: coupenCode } : null,
        is_discounted_order: coupenData ? true : null,
        order_id: null,
        is_new_order: true,
        order_user: selectedUser?._id, // Replace with actual user ID
      };

      const apiResponse = await API_CALCULATE_AMOUNT(payload);

      console.log("calucalte", apiResponse);

      if (apiResponse) {
        setPaymentInfo({
          amountDue: apiResponse?.data?.amountDue || 0,
          amountPaid: apiResponse?.data?.amountPaid || 0,
          deliveryFee: apiResponse?.data?.deliveryFee || 0,
          discount: apiResponse?.data?.discount || 0,
          subtotal: apiResponse?.data?.subtotal || 0,
          taxAmount: apiResponse?.data?.taxAmount || 0,
          totalAmount: apiResponse?.data?.totalAmount || 0,
        });
      }
    } catch (error) {
      console.error("error", error);
      // toast.error(error?.response?.data?.message);
    } finally {
      // setSubmitting(false);
    }
  };
  useEffect(() => {
    calculateAmount();
  }, [totalItems, alItemsList, itemCounts, coupenData]);

  return (
    <>
      <div className=" ">
        <div className="mb-4">
          <div className="mb-4">
            <Row gutter={[16, 16]}>
              {/* <Col span={12}>
                <div className="relative">
                  <label
                    for="floating_outlined"
                    className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-[17px] text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                    style={{ fontSize: "17px" }}
                  >
                    Select Laundry
                  </label>
                  <Select
                    // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none "
                    className="bg-transparent peer block h-[3rem] w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                    // {...field}
                    // value={mainLaundry?.laundry_name}
                    showSearch
                    placeholder="Select Laundry"
                    optionFilterProp="children"
                    onPopupScroll={handleScroll}
                    filterOption={(input, option) =>
                      option?.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    loading={loading}
                    onChange={(value) => {
                      console.log("value", value);
                      setMainLaundry(value);
                      // setFieldValue("laundry", value);
                      // setTouched({ laundry: true });
                    }}
                  >
                    {data?.map((item) => (
                      <Option key={item._id} value={item._id}>
                        {item.laundry_name}
                      </Option>
                    ))}
                  </Select>
                </div>
              </Col> */}
              {process.env.REACT_APP_APPLICATION_NAME === "admin" ? (
                <Col span={12}>
                  <div className="relative">
                    <label
                      for="floating_outlined"
                      className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-[17px] text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      style={{ fontSize: "17px" }}
                    >
                      {t("Select Store")}
                    </label>
                    <Select
                      // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none "
                      className="bg-transparent peer block h-[3rem] w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                      // {...field}
                      // value={store}
                      showSearch
                      placeholder="Select Store"
                      optionFilterProp="children"
                      onPopupScroll={handleScrollStore}
                      filterOption={(input, option) =>
                        option?.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      loading={loadingStore}
                      onChange={(value) => {
                        console.log("value", value);
                        setStore(value);
                        const selected = dataStore.find(
                          (store) => store._id === value
                        );
                        setSelectedStore(selected);
                        // setFieldValue("laundry", value);
                        // setTouched({ laundry: true });
                      }}
                    >
                      {dataStore?.map((item) => (
                        <Option key={item._id} value={item?._id}>
                          {item.store_name}
                        </Option>
                      ))}
                    </Select>
                  </div>
                </Col>
              ) : (
                ""
              )}
            </Row>
          </div>
          <div className="flex items-center justify-between gap-8 text-xl font-semibold">
            <div className="flex items-center space-x-4 ">
              <span className="">
                {selectedUser ? (
                  <img
                    src={
                      CONSTANTS?.IMG_DIRECTORY +
                      selectedUser?.profile_image?.[0]?.file_url
                    }
                    style={{
                      height: "5rem",
                      width: "5rem",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                    alt=""
                  />
                ) : (
                  <img src={LocationIcon} alt="" />
                )}
              </span>{" "}
              <div>
                <span className="font-poppins text-[15px] font-medium text-[#3860A4]">
                  {selectedUser
                    ? selectedUser?.first_name + " " + selectedUser?.last_name
                    : t("No user Info")}
                </span>
                <div className="font-poppins text-[12px] font-medium text-[#9496AE]">
                  {/* {selectedUser?.location
                    ? selectedUser?.location
                    : "No Location Availble"} */}
                  {selectedUser?.address?.map((element) => {
                    const check = element?.is_selected;
                    return <div>{check ? element?.location : null} </div>;
                  })}
                  {/* No.45 - al Riyadh Province 123334, building */}
                </div>
              </div>
            </div>
            {selectedUser && (
              <div onClick={() => setModalVisibleUser(true)}>
                <img src={EditIcon} alt="" />
              </div>
            )}
            {!selectedUser && (
              <Button
                className="btn-gradient  ml-auto flex w-40 items-center justify-center p-5 text-[white]"
                onClick={() => setModalVisibleUser(true)}
              >
                {t("Add New Customer")}
              </Button>
            )}
          </div>

          <div className="mb-6 ml-4 mt-6 flex justify-between space-x-4">
            <div>
              <h3 className="text[12.9px] mb-1 font-[inter] text-lg font-normal text-[#232323]">
                {t("Customer Type")}
              </h3>
              <div className="mr-3 flex gap-[0.3rem]">
                <div className="checkbox-wrapper-40">
                  <div className="flex gap-1">
                    <input
                      type="checkbox"
                      className="cursor-pointer"
                      style={{
                        border:
                          selectedCustmerType === "walking"
                            ? "1px solid #46BCED"
                            : "1px solid #ccc",
                        height: "18px",
                        width: "18px",
                      }}
                      checked={selectedCustmerType === "walking"}
                      onChange={() => handleCheckboxChange("walking")}
                    />
                    <span
                      className={`checkbox text-[12px] ${
                        selectedCustmerType === "walking"
                          ? "text-[#3860A4]"
                          : "#8B8B8B"
                      }`}
                    >
                      {t("Walking")}
                    </span>
                  </div>
                </div>

                <div class="checkbox-wrapper-40">
                  <div className="flex gap-1">
                    <input
                      type="checkbox"
                      className="ml-1 cursor-pointer"
                      style={{
                        border:
                          selectedCustmerType === "call"
                            ? "1px solid #46BCED"
                            : "1px solid #ccc",
                        height: "18px",
                        width: "18px",
                      }}
                      checked={selectedCustmerType === "call"}
                      onChange={() => handleCheckboxChange("call")}
                    />
                    <span
                      className={`checkbox text-[12px] ${
                        selectedCustmerType === "call"
                          ? "text-[#3860A4]"
                          : "#8B8B8B"
                      }`}
                    >
                      {t("Call")}
                    </span>
                  </div>
                </div>

                <div class="checkbox-wrapper-40 mr-1">
                  <div className="flex gap-1">
                    <input
                      type="checkbox"
                      className="ml-1 cursor-pointer"
                      style={{
                        border:
                          selectedCustmerType === "app"
                            ? "1px solid #46BCED"
                            : "1px solid #ccc",
                        height: "18px",
                        width: "18px",
                      }}
                      checked={selectedCustmerType === "app"}
                      onChange={() => handleCheckboxChange("app")}
                    />
                    <span
                      className={`checkbox text-[12px] ${
                        selectedCustmerType === "app"
                          ? "text-[#3860A4]"
                          : "#8B8B8B"
                      }`}
                    >
                      {t("App")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex items-center gap-4 ">
              <div
                className="relative h-auto cursor-pointer rounded-lg bg-[#ceaf8917] px-[13px] py-[10px] text-[12px]"
                style={{
                  border: "1px solid #CEAF89",
                  // paddingBottom: "8px",
                  // paddingTop: "8px",
                }}
                onClick={() => {
                  if (selectedCustmerType === "call") {
                    handleConfirm();
                    setSlotVisible(true);
                  }
                }}
              >
                <div className="absolute left-[6px] top-[-6px] rounded-[3.13px] bg-[#FAF7F3] px-1 text-[9px] text-[#F4B718]">
                  {/* <img src={editCollection} /> */}
                  {t("Pickup Time & Date")}
                </div>
                <div className="absolute left-[6px] right-0 top-0 flex justify-end">
                  <img src={collectionDate} className="h-4" alt="" />
                </div>

                {selectedCustmerType === "call"
                  ? pickUpTime?.from
                    ? moment.unix(pickUpTime?.from).format("h A") +
                      " - " +
                      moment.unix(pickUpTime?.to).format("h A ddd, MMM D, YYYY")
                    : "Select Pickup Time"
                  : moment().format("h A ddd, MMM D, YYYY")}
              </div>

              <div
                className="relative h-auto cursor-pointer rounded-lg bg-[#1cab4324] px-[13px] py-[10px]   text-[12px]"
                style={{
                  border: "1px solid #1CAB43",
                  // paddingBottom: "8px",
                  // paddingTop: "8px",
                }}
                onClick={() => {
                  handleConfirm({
                    from: moment(new Date()).unix(),
                    to: moment(new Date()).unix(),
                  });
                  setSlotVisibleDelvery(true);
                  console.log("iam clickedddddd");
                  setPickUpTime({
                    from: moment(new Date()).unix(),
                    to: moment(new Date()).unix(),
                  });
                }}
              >
                <div className="absolute left-[6px] top-[-6px]">
                  <img src={deliverytime} alt="" />
                </div>
                <div className="absolute left-[6px] right-0 top-0 flex justify-end">
                  <img src={editdeleivery} className="h-4" alt="" />
                </div>
                {/* 9Am -11Am Tue, 2024 */}
                {deliveryTime
                  ? moment.unix(deliveryTime.from).format("h A") +
                    " - " +
                    moment.unix(deliveryTime.to).format("h A ddd, MMM D, YYYY")
                  : t("Select Delivery Time")}
              </div>
            </div>
          </div>
          <hr />
        </div>

        <div className="scroll- mb-4 max-h-96 min-h-96 overflow-x-hidden overflow-y-scroll">
          <h2 className="mb-4 font-[inter] text-lg font-semibold text-[#232323]">
            {t("Selected Items")}
          </h2>
          <div className="">
            {console.log(alItemsList, "allItemListCardOrder")}
            {alItemsList?.length > 0
              ? alItemsList?.map((item, idx) => {
                  // const itemCount = itemCounts[item._id] || 1;
                  const totalPrice = calculateTotalPrice(item);
                  const totalCount = item?.item_service.reduce(
                    (countSum, service) => {
                      return countSum + (itemCounts[service._id] || 0);
                    },
                    0
                  );

                  return (
                    <div className="relative" key={idx}>
                      <Card
                        className="side-card  mb-3 cursor-pointer rounded-lg border shadow-sm"
                        onClick={() => {
                          handleCardClick(item);
                        }}
                      >
                        <div className=" flex flex-row items-center justify-between pb-0 pt-0">
                          <div className="flex  w-1/2 gap-2">
                            <div>
                              <img
                                src={
                                  CONSTANTS?.IMG_DIRECTORY +
                                  item?.images?.[0]?.file_url
                                }
                                alt="Thobe Summer"
                                className="h-12 w-12 rounded-[50%]"
                              />
                            </div>
                            <div>
                              <h3 className="font-poppins font-semibold text-[#3860A4]">
                                {item?.name}
                              </h3>
                              <p className="text-sm text-gray-500">
                                {item?.item_service?.[0]?.service_info?.name}
                              </p>
                            </div>
                          </div>
                          {/*                           
                          <div className="grid grid-cols-2 gap-2 w-1/2">
                            {item?.item_service?.map((element, idx) => {
                              const iddddds = itemCounts[element?._id];
                              const countExists = iddddds > 0
                              return (<div key={idx}>
                                {countExists ? <p key={idx} className="text-sm text-gray-500">
                                  {element?.service_info?.name}
                                </p> : ''}
                              </div>   
                              );
                            })}
                          </div> */}
                          <div className="grid w-1/2 grid-cols-2 gap-2">
                            {item?.item_service?.map((element, idx) => {
                              const iddddds = itemCounts[element?._id];
                              const countExists = iddddds > 0;
                              return countExists ? (
                                <div key={idx}>
                                  <p className="text-sm text-gray-500">
                                    {element?.service_info?.name}
                                  </p>
                                </div>
                              ) : null; // Use null instead of an empty string to avoid creating empty grid cells
                            })}
                          </div>

                          <div className="w-1/4 text-center">
                            <p className=" font-poppins font-semibold text-[#3860A4]">
                              {t("SAR")}
                              {totalPrice}
                            </p>
                          </div>

                          <div
                            className="flex  w-1/4 space-x-4 bg-[#172e5512]"
                            style={{
                              padding: "4px 6px",
                              borderRadius: "100px",
                            }}
                          >
                            <img
                              src={minusIcon}
                              className="w-[1.2rem]"
                              // onClick={() => {
                              //   handleCountMinus(item._id);
                              // }}
                              alt=""
                            />{" "}
                            <p className="text-600 text-[#3860A4]">
                              {/* {itemsCount} */}
                              {totalCount}

                              {/* {itemCounts[item._id] || 1} */}
                            </p>{" "}
                            <img
                              src={plusIcon}
                              className="w-[1.2rem]"
                              // onClick={() => {
                              //   handleCountPlus(item._id);
                              // }}
                              alt=""
                            />
                            <div
                              className="absolute "
                              style={{
                                right: "0px",
                                bottom: "0px",
                                top: "-19px",
                                left: "-21px",
                              }}
                            >
                              <Button
                                type="text"
                                icon={
                                  <TiDelete style={{ fontSize: "1.5rem" }} />
                                }
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent the card click event
                                  // handleRemoveClick(item);
                                  setItemToDelete(item);
                                  setIsDeleteModalVisible(true);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </Card>
                    </div>
                  );
                })
              : t("No Selected Item")}
          </div>
        </div>
        <Modal
          visible={isDeleteModalVisible}
          centered
          onCancel={() => {
            setIsDeleteModalVisible(false);
          }}
        >
          <div className="mt-7 flex w-full flex-col items-center justify-center gap-2">
            <h1 className="w-[300px] text-center font-poppins text-[18px] font-medium leading-[28px]">
              {t("Are you sure you want to delete this item?")}
            </h1>
            <div className="flex flex-row items-center gap-2">
              <Button
                className=" text-black flex  w-40 p-5"
                onClick={() => setIsDeleteModalVisible(false)}
              >
                {t("Cancel")}
              </Button>
              <Button
                className="btn-gradient   flex w-40  p-5 text-[white]"
                onClick={() => handleRemoveClick(itemToDelete)}
              >
                {t("Confirm")}
              </Button>
            </div>
          </div>
        </Modal>
        <div className="mb-4">
          <hr className="mb-4" />
          <div className="flex items-baseline justify-between gap-1">
            {/* <p className="font-inter font-semibold text-[#232323] mb-4">Order Summary :</p>{" "} */}
            <div className="flex items-baseline ">
              <h2 className="text-lg font-medium ">{t("Order Summary :")}</h2>
              <span className="mb-4 font-poppins font-semibold  text-[#46BCED]">
                &nbsp;
                {coupenData
                  ? `${coupenCode}: Coupon Applied`
                  : t("No Coupon Availble")}
              </span>
            </div>

            {coupenData ? (
              <p
                className="cursor-pointer text-[15px] font-medium text-[#4732F4]"
                style={{ borderBottom: "1px solid" }}
                onClick={() => {
                  setCoupenCode("");
                  setCoupenData("");
                }}
              >
                {t("Remove Coupon")}
              </p>
            ) : (
              <p
                className="cursor-pointer text-[15px] font-medium text-[#4732F4]"
                style={{ borderBottom: "1px solid" }}
                onClick={() => {
                  setCoupenVisible(true);
                }}
              >
                {t("Add Coupon")}
              </p>
            )}
            {/* <p
              className="cursor-pointer text-[15px] font-medium text-[#4732F4]"
              style={{ borderBottom: "1px solid" }}
              onClick={() => {
                setCoupenVisible(true);
              }}
            >
              {coupenData ? "Remove Coupon" : "Add Coupon"}
            </p> */}
          </div>
          <div className="flex justify-between">
            <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
              {t("Service Category")}
            </span>
            <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
              {t("Normal")}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
              {t("Total Items")}
            </span>
            <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
              {totalItems} {t("Items")}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
              {t("Service Charges")}
            </span>
            <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
              {Number(totalPrice).toFixed(2) ?? 0} {t("SAR")}
            </span>
          </div>

          <div className="flex justify-between">
            <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
              {t("Tax")}
            </span>
            <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
              {/* {Number(tax).toFixed(2)} SAR */}
              {Number(paymentInfo?.taxAmount).toFixed(2)} {t("SAR")}
            </span>
          </div>

          {/* {!coupenData && ( */}
          <div className="flex justify-between">
            <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
              {t("Delivery Fee")}
            </span>
            <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
              {/* {Number(deliveryFee).toFixed(2)} SAR */}
              {Number(paymentInfo?.deliveryFee).toFixed(2)} {t("SAR")}
            </span>
          </div>
          {/* )} */}
          {coupenData && (
            <div className="flex justify-between">
              <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                {t("Discount")}
              </span>
              <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
                {/* {coupenData?.coupon_discount}{" "}
                {coupenData?.coupon_type === "percentage" ? "%" : "SAR"} */}
                {Number(paymentInfo?.discount).toFixed(2)} {t("SAR")}
              </span>
            </div>
          )}

          {coupenData && alItemsList?.length ? (
            <>
              <div className="flex justify-between">
                <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                  {t("Total Before Discount")}
                </span>
                {/* <span className="font-poppins text-[15px] font-semibold text-[#FF0000]">
                {alItemsList?.length > 0
                  ? Number(total_calulated_price_withoutdilivery).toFixed(2)
                  : 0}{" "}
                SAR
              </span> */}
                <span className="font-poppins text-[15px] font-semibold text-[#FF0000]">
                  {Number(
                    paymentInfo?.totalAmount + paymentInfo?.discount
                  ).toFixed(2)}{" "}
                  {t("SAR")}
                </span>
              </div>

              <div className="flex justify-between">
                <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                  {t("Total After Discount")}
                </span>
                {/* <span className="font-poppins text-[15px] font-semibold text-[#FF0000]">
                {alItemsList?.length > 0
                  ? Number(total_calulated_price_withoutdilivery).toFixed(2)
                  : 0}{" "}
                SAR
              </span> */}
                <span className="font-poppins text-[15px] font-semibold text-[green]">
                  {Number(paymentInfo?.totalAmount).toFixed(2)} SAR
                </span>
              </div>
            </>
          ) : (
            <div className="flex justify-between">
              <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                {t("Total")}
              </span>
              <span className="font-poppins text-[15px] font-semibold text-[#FF0000]">
                {/* {alItemsList?.length > 0
                  ? Number(totalPrice + deliveryFee + tax).toFixed(2)
                  : 0}{" "}
                SAR */}
                {Number(paymentInfo?.totalAmount).toFixed(2)} SAR
              </span>
            </div>
          )}

          {/* {coupenData && alItemsList?.length > 0 && (
            <div className="flex justify-between">
              <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                Delivery Fee
              </span>
              <span className="font-poppins text-[15px] font-semibold text-[#df4b4b]">
                {Number(deliveryFee).toFixed(2)} SAR
              </span>
            </div>
          )} */}

          {/* {coupenData && alItemsList?.length > 0 && (
            <div className="flex items-center justify-between">
              <span className="mt-4 font-poppins text-[#9496AE]">Total</span>
              <span className="mt-4 font-poppins text-xl font-semibold text-red-500">
                {Number(total_calulated_price).toFixed(2)} SAR
              </span>
            </div>
          )} */}
        </div>
        <hr className="mb-4 mt-4" />

        <div className="mb-4">
          <div className="flex justify-between">
            <h2 className="text-lg font-medium">{t("Payment")}</h2>
            <p
              className="cursor-pointer text-[15px] font-medium text-[#4732F4]"
              style={{ borderBottom: "1px solid" }}
              onClick={() => {
                setPaymentVisible(true);
              }}
            >
              {t("Add Payment Method")}
            </p>
          </div>
        </div>
        <hr className="mb-4 mt-4" />

        <div className="relative mb-3">
          <label
            for="floating_outlined"
            className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
          >
            {t("Add Note")}
          </label>
          <input
            // className="mt-2 flex h-11 w-full items-center justify-center rounded-2xl border bg-white p-3 text-sm outline-none "
            className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
            type="text"
            name="order_note"
            placeholder={t("order Note")}
            onChange={(event) => setOrderNote(event.target.value)}
            // maxLength={20}
            // onKeyPress={(event) => {
            //   const charCode = event.charCode;
            //   if (
            //     !(charCode >= 65 && charCode <= 90) && // A-Z
            //     !(charCode >= 97 && charCode <= 122) && // a-z
            //     charCode !== 32 // space
            //   ) {
            //     event.preventDefault();
            //   }
            // }}
            // autoComplete="off"
          />
        </div>

        <hr className="mb-4 mt-4" />

        <Button
          className="btn-gradient  ml-auto flex w-40 items-center justify-center p-5 text-[white]"
          onClick={createOrder}
        >
          {loadingorder ? t("Creating...") : t("Create Order")}
        </Button>
      </div>

      <Modal
        // title="Item Details"
        visible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          // if (selectedItem) {
          //   // Update notes for the selected item
          //   updateNote(selectedItem._id, itemNotes[selectedItem._id] ?? "");

          // }
        }}
      >
        {" "}
        <DetailModalCards
          itemCounts={itemCounts}
          handleCountMinus={handleCountMinus}
          handleCountPlus={handleCountPlus}
          selectedItem={selectedItem}
          totalPrice={totalPrice}
          setTotalPrice={setTotalPrice}
          itemNotes={itemNotes}
          updateNote={updateNote}

          // itemCounts={itemCounts}
          // handleCountMinus={handleCountMinus}
          // handleCountPlus={handleCountPlus}
          // selectedItem={selectedItem}
        />
      </Modal>

      <Modal
        visible={slotVisible}
        onCancel={() => setSlotVisible(false)}
        style={{ minWidth: "35rem" }}
        className="order-modal-payment"
      >
        <div className="mb-6">
          <CalendarSlot onConfirm={handleConfirm} />
        </div>
      </Modal>
      <Modal
        visible={slotVisibleDelvery}
        // onCancel={() => setSlotVisibleDelvery(false)}
        onCancel={closeDeliveryModal}
        style={{ minWidth: "35rem" }}
        className="order-modal-payment"
      >
        {console.log(pickUpTime, "CalendarSlotDelivery")}
        {console.log("fdksjfsdfs", selectedOrderType)}
        <div className="mb-6">
          {/* <CalendarSlot onConfirm={handleConfirm} /> */}
          <CalendarSlotDelivery
            onConfirm={handleConfirm}
            selectedOrderType={selectedOrderType}
            pickUpTime={pickUpTime}
            setPickUpTime={setPickUpTime}
            setSelectedOrderType={setSelectedOrderType}
          />
        </div>
      </Modal>

      <Modal
        visible={paymentVisible}
        onCancel={() => setPaymentVisible(false)}
        style={{ minWidth: "35rem" }}
        className="order-modal-payment"
      >
        <div className="mb-6">
          {/* <PaymentModal total_calulated_price ={total_calulated_price}/> */}
          <div className=" rounded-md bg-white p-4 shadow-md">
            <h2 className="mb-4 font-poppins text-xl font-semibold text-[#3860A4]">
              {t("Payment")}
            </h2>
            <hr className="text-[#C5C5C5]" />

            <div className="mb-4">
              <div className="mb-4">
                <label className="mb-3 mt-3 block font-poppins font-medium text-[#3860A4]">
                  {t("Select Payment Method")}
                </label>
                <div className="flex justify-between">
                  <label
                    className={`mr-2 flex flex-1 cursor-pointer items-center justify-between rounded-md border p-2 shadow-md
                 ${
                   paymentMethod === "cash_on_delivery"
                     ? "bosrder-[#46BCEsssssD]sasa"
                     : "bordser-grassssy-300"
                 }`}
                  >
                    <div>
                      <span>
                        <img
                          src={cashondelivery}
                          alt="Cash On Delivery"
                          className="h-6 w-6"
                        />
                      </span>
                      <span className="font-poppins font-medium text-[#3860A4]">
                        {t("Cash On Delivery")}
                      </span>
                    </div>
                    <div>
                      <input
                        type="radio"
                        name="paymentMethod"
                        value="cash_on_delivery"
                        onChange={handleRadioChange}
                      />
                    </div>
                  </label>
                  <label
                    className={`mr-2 flex flex-1 cursor-pointer items-center justify-between rounded-md border p-2 shadow-md ${
                      paymentMethod === "credit_card"
                        ? "bordedsdr-[#46BCED]"
                        : "bordsder-gray-300"
                    }`}
                  >
                    <div>
                      <span>
                        <img
                          src={creditCard}
                          alt="Credit Card"
                          className="h-6 w-6"
                        />
                      </span>
                      <span className="font-poppins font-medium text-[#3860A4]">
                        {t("Credit Card")}
                      </span>
                    </div>

                    <input
                      type="radio"
                      name="paymentMethod"
                      value="credit_card"
                      onChange={handleRadioChange}
                    />
                  </label>
                  <label
                    className={`flex flex-1 cursor-pointer  items-center justify-between rounded-md border p-2 shadow-md ${
                      paymentMethod === "hand_cash"
                        ? "borddser-[#46BCED]"
                        : "borddsder-gray-300"
                    }`}
                  >
                    <div>
                      <span>
                        <img
                          src={handonCash}
                          alt="Hand Cash"
                          className="h-6 w-6"
                        />
                      </span>
                      <span className="font-poppins font-medium text-[#3860A4]">
                        {t("Hand Cash")}
                      </span>
                    </div>
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="hand_cash"
                      onChange={handleRadioChange}
                    />
                  </label>
                </div>
              </div>
            </div>
            <hr className="text-[#C5C5C5]" />

            <div className="mb-4">
              <div className="flex items-center justify-between">
                <span className="mt-4 font-poppins text-[#9496AE]">{t("Total")}</span>
                <span className="mt-4 font-poppins text-xl font-semibold text-red-500">
                  {/* {alItemsList?.length > 0
                    ? coupenData
                      ? Number(total_calulated_price).toFixed(2)
                      : Number(totalPrice + deliveryFee + tax).toFixed(2)
                    : 0}{" "} */}
                  {Number(paymentInfo?.totalAmount).toFixed(2)}
                  {t("SAR")}
                </span>
              </div>
            </div>
            <hr className="text-[#C5C5C5]" />

            <div className="mb-4 mt-4 flex items-center gap-5">
              <label className=" block font-poppins text-[#3860A4]">
                {t("Payment Status:")}
              </label>
              {/* <div className="flex items-center">
                <Checkbox className="mr-2">Unpaid</Checkbox>
                <Checkbox>Paid</Checkbox>
              </div> */}
              <div className="mr-3 flex gap-[0.3rem]">
                <div className="checkbox-wrapper-40">
                  <div className="flex gap-1">
                    <input
                      type="checkbox"
                      className="cursor-pointer"
                      style={{
                        border:
                          selectedPaymentStatus === "unpaid"
                            ? "1px solid #46BCED"
                            : "1px solid #ccc",
                        height: "18px",
                        width: "18px",
                      }}
                      checked={selectedPaymentStatus === "unpaid"}
                      onChange={() => handleCheckboxChangeStatus("unpaid")}
                    />
                    <span
                      className={`checkbox text-[12px] ${
                        selectedPaymentStatus === "unpaid"
                          ? "text-[#3860A4]"
                          : "#8B8B8B"
                      }`}
                    >
                      Unpaid
                    </span>
                  </div>
                </div>

                <div class="checkbox-wrapper-40">
                  <div className="flex gap-1">
                    <input
                      type="checkbox"
                      className="ml-1 cursor-pointer"
                      style={{
                        border:
                          selectedPaymentStatus === "paid"
                            ? "1px solid #46BCED"
                            : "1px solid #ccc",
                        height: "18px",
                        width: "18px",
                      }}
                      checked={selectedPaymentStatus === "paid"}
                      onChange={() => handleCheckboxChangeStatus("paid")}
                    />
                    <span
                      className={`checkbox text-[12px] ${
                        selectedPaymentStatus === "paid"
                          ? "text-[#3860A4]"
                          : "#8B8B8B"
                      }`}
                    >
                      Paid
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <hr className="text-[#C5C5C5]" />

            <Button
              className="btn-gradient  mx-auto ml-auto mt-3 flex w-48 items-center justify-center rounded-xl p-5 text-[white]"
              onClick={() => {
                setPaymentVisible(false);
              }}
            >
              Confirm Payment
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        visible={coupenVisible}
        onCancel={() => setCoupenVisible(false)}
        style={{ minWidth: "35rem" }}
        className="order-modal-payment"
      >
        <div className="mb-6">
          <div className=" rounded-lg bg-white p-4 shadow-md">
            <h2 className="mb-4 font-poppins text-xl font-semibold text-[#3860A4]">
              Add Coupon
            </h2>
            <hr className="text-[#C5C5C5]" />

            <div className="mb-4">
              <p className="mb-4 mt-4 font-poppins font-normal text-[#9496AE]">
                Enter your coupon code
              </p>
              <div className="relative">
                <label
                  for="floating_outlined"
                  className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                >
                  Add Coupen Code
                </label>
                <div className="flex items-center gap-1">
                  <input
                    className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                    value={coupenCode}
                    onChange={(event) => {
                      setCoupenCode(event.target.value);
                    }}
                  />
                  <Button
                    className="btn-gradient  ml-auto flex w-40 items-center justify-center p-5 py-6 text-[white]"
                    onClick={() => handleApplyCoupon()}
                  >
                    Apply
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        visible={modalVisibleUser}
        onCancel={() => setModalVisibleUser(false)}
        style={{ minWidth: "67rem" }}
        className="order-modal"
      >
        <div className="mb-6">
          <CreateOrderUser
            onSuccessModal={() => {
              setModalVisibleUser(false);
            }}
          />
        </div>
      </Modal>

      <Modal
        visible={modalVisibleOrder}
        onCancel={() => setModalVisibleOrder(false)}
        // style={{ minWidth: "67rem" }}
        // className="order-modal"
      >
        <div className="mb-6">
          {/* <p className="text-center">
            {" "}
            Payment Method (
            <span className="font-medium">
              {paymentMethod === "hand_cash" ? "Hand Cash" : paymentMethod}
            </span>
            ){" "}
          </p> */}

          <div className="flex justify-center">
            <svg
              width="80"
              height="73"
              viewBox="0 0 80 73"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M56.2295 0H20.8809C18.2157 0 16.0552 2.39546 16.0552 5.35059V67.6494C16.0552 70.6043 18.2157 73 20.8809 73H56.2295C58.8946 73 61.0552 70.6043 61.0552 67.6494V5.35059C61.0552 2.39546 58.8946 0 56.2295 0Z"
                fill="#3860A4"
              />
              <path
                d="M58.0552 10H19.0552V63H58.0552V10Z"
                fill="white"
                fill-opacity="0.15"
              />
              <path
                d="M44.6056 4H32.9912C32.2623 4 31.6714 4.59087 31.6714 5.31963C31.6714 6.04859 32.2623 6.63968 32.9912 6.63968H44.6056C45.3345 6.63968 45.9255 6.04859 45.9255 5.31963C45.9255 4.59087 45.3345 4 44.6056 4Z"
                fill="#42B9EB"
              />
              <path
                d="M38.798 71.0111C40.0683 71.0111 41.098 69.9814 41.098 68.7111C41.098 67.4409 40.0683 66.4111 38.798 66.4111C37.5278 66.4111 36.498 67.4409 36.498 68.7111C36.498 69.9814 37.5278 71.0111 38.798 71.0111Z"
                fill="#42B9EB"
              />
              <path
                d="M78.2194 20H34.4995C33.5161 20 32.719 20.7972 32.719 21.7805V45.3022C32.719 46.2855 33.5161 47.0828 34.4995 47.0828H39.8891V52.297L45.1033 47.0828H78.2194C79.2028 47.0828 80 46.2855 80 45.3022V21.7805C80 20.7972 79.2028 20 78.2194 20Z"
                fill="#F0CD81"
              />
              <path
                d="M35.4062 22.686V44.3957H77.3139V22.686L35.4062 22.686Z"
                fill="#E6AB2D"
              />
              <path
                d="M56.359 39.8875C59.8636 39.8875 62.7046 37.0464 62.7046 33.5419C62.7046 30.0374 59.8636 27.1964 56.359 27.1964C52.8544 27.1964 50.0134 30.0374 50.0134 33.5419C50.0134 37.0464 52.8544 39.8875 56.359 39.8875Z"
                fill="white"
                fill-opacity="0.4"
              />
              <path
                d="M43.9963 35.5537C45.1076 35.5537 46.0084 34.6528 46.0084 33.5415C46.0084 32.4302 45.1076 31.5294 43.9963 31.5294C42.885 31.5294 41.9841 32.4302 41.9841 33.5415C41.9841 34.6528 42.885 35.5537 43.9963 35.5537Z"
                fill="white"
                fill-opacity="0.4"
              />
              <path
                d="M68.7216 35.5537C69.8329 35.5537 70.7338 34.6528 70.7338 33.5415C70.7338 32.4302 69.8329 31.5294 68.7216 31.5294C67.6104 31.5294 66.7095 32.4302 66.7095 33.5415C66.7095 34.6528 67.6104 35.5537 68.7216 35.5537Z"
                fill="white"
                fill-opacity="0.4"
              />
              <path
                d="M56.1439 37.6033V36.7963C55.7405 36.7455 55.4124 36.6551 55.1599 36.5251C54.9073 36.3951 54.6892 36.1851 54.5054 35.8952C54.3216 35.6053 54.2147 35.2512 54.1848 34.8327L54.9963 34.6803C55.059 35.1137 55.1696 35.432 55.328 35.6352C55.5551 35.9221 55.8271 36.082 56.1439 36.1149V33.5461C55.8122 33.4833 55.473 33.3548 55.1263 33.1605C54.8692 33.0171 54.6712 32.8183 54.5323 32.5643C54.3933 32.3102 54.3238 32.0218 54.3238 31.6991C54.3238 31.1252 54.527 30.6605 54.9335 30.3048C55.2055 30.0657 55.6089 29.9193 56.1439 29.8655V29.4799H56.6191V29.8655C57.0884 29.9103 57.4605 30.0478 57.7354 30.2779C58.0881 30.5708 58.3003 30.9728 58.372 31.4839L57.5382 31.6094C57.4904 31.2926 57.391 31.0498 57.24 30.8809C57.0891 30.712 56.8821 30.6007 56.6191 30.5469V32.8736C57.0256 32.9752 57.2946 33.0544 57.4261 33.1112C57.6772 33.2218 57.8819 33.3563 58.0403 33.5147C58.1987 33.6731 58.3205 33.8614 58.4057 34.0796C58.4908 34.2978 58.5334 34.5339 58.5334 34.7879C58.5334 35.3468 58.3556 35.813 57.9999 36.1866C57.6443 36.5602 57.184 36.7605 56.6191 36.7874V37.6033H56.1439ZM56.1439 30.5379C55.8301 30.5858 55.5828 30.7113 55.402 30.9145C55.2212 31.1177 55.1308 31.3583 55.1308 31.6363C55.1308 31.9113 55.2077 32.1414 55.3616 32.3267C55.5156 32.512 55.7763 32.6599 56.1439 32.7705V30.5379ZM56.6191 36.1149C56.933 36.0761 57.1922 35.9401 57.397 35.7069C57.6017 35.4738 57.7041 35.1854 57.7041 34.8417C57.7041 34.5488 57.6316 34.3134 57.4866 34.1356C57.3417 33.9578 57.0525 33.7986 56.6191 33.6582V36.1149Z"
                fill="#E6AB2D"
              />
            </svg>
          </div>

          <p className="mt-2 text-center text-[Gray]">
            You have to pay 50 SAR in advance to confirm your order, this amount
            will be adjusted in your order payment
          </p>

          <input
            placeholder="Enter Amount"
            value={partialAmount}
            className="bg-transparent peer mt-5 block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
            onChange={(event) => {
              setPartialAmount(event.target.value);
            }}
            min={0}
            type="number"
          />
          <Button
            className="btn-gradient   mx-auto mt-4  flex w-40 p-5 text-[white]"
            onClick={RecivedAmount}
            disabled={loading}
          >
            {loading ? "Receiving..." : "Received"}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default OrderCard;
